export var AIBotPromptActionEnum;
(function (AIBotPromptActionEnum) {
    AIBotPromptActionEnum["CONNECT_TO_AGENT"] = "CONNECT_TO_AGENT";
    AIBotPromptActionEnum["MESSAGE"] = "MESSAGE";
})(AIBotPromptActionEnum || (AIBotPromptActionEnum = {}));
export var MessageByTypeEnum;
(function (MessageByTypeEnum) {
    MessageByTypeEnum["Agent"] = "Agent";
    MessageByTypeEnum["GPT"] = "GPT";
    MessageByTypeEnum["Visitor"] = "Visitor";
    MessageByTypeEnum["System"] = "System";
})(MessageByTypeEnum || (MessageByTypeEnum = {}));
export var ChatSessionConnectedWithEnum;
(function (ChatSessionConnectedWithEnum) {
    ChatSessionConnectedWithEnum["AGENT"] = "AGENT";
    ChatSessionConnectedWithEnum["GPT"] = "GPT";
})(ChatSessionConnectedWithEnum || (ChatSessionConnectedWithEnum = {}));
export var AppStateComponentsEnum;
(function (AppStateComponentsEnum) {
    AppStateComponentsEnum[AppStateComponentsEnum["LOADER"] = 0] = "LOADER";
    AppStateComponentsEnum[AppStateComponentsEnum["CONVERSATIONLIST"] = 1] = "CONVERSATIONLIST";
    AppStateComponentsEnum[AppStateComponentsEnum["CONVERSATION"] = 2] = "CONVERSATION";
})(AppStateComponentsEnum || (AppStateComponentsEnum = {}));
export var SessionStateEnum;
(function (SessionStateEnum) {
    SessionStateEnum["NEW_SESSION"] = "NEW_SESSION";
    SessionStateEnum["DB_SESSION"] = "DB_SESSION";
})(SessionStateEnum || (SessionStateEnum = {}));
export var MessageFormatType;
(function (MessageFormatType) {
    MessageFormatType["FILE"] = "FILE";
    MessageFormatType["TEXT"] = "TEXT";
    MessageFormatType["FETCHING"] = "FETCHING";
    MessageFormatType["FLOW_NODE"] = "FLOW_NODE";
})(MessageFormatType || (MessageFormatType = {}));
